<template>
  <div class="admins">
    <div class="list mh-100">
      <div class="controlls pa-2 mt-2">
        <v-text-field label="Sök" outlined dense hide-details v-model="search"></v-text-field>
        <v-btn
          class="add-button"
          :loading="loading"
          fab
          x-small
          color="primary"
          @click="createUserDialog = true"
        >
          <v-icon dark> mdi-plus </v-icon>
        </v-btn>
      </div>
      <v-list class="list-inner pt-0" dense nav>
        <v-subheader>Redaktörer</v-subheader>
        <v-list-item-group v-model="selectedItem" color="primary">
          <v-list-item v-for="(user, i) in users" :key="i" @click="onClick(user)">
            <v-list-item-icon>
              <v-avatar color="primary" size="24"
                ><span class="avatar-text">{{ user.abbr }}</span></v-avatar
              >
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ user.admin_name }}</v-list-item-title>
              <v-list-item-subtitle v-if="user.admin_role === DEVELOPER"
                >Utvecklare</v-list-item-subtitle
              >
              <v-list-item-subtitle v-else-if="user.admin_role === ADMIN"
                >Administratör</v-list-item-subtitle
              >
              <v-list-item-subtitle v-else>Användare</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </div>
    <div class="content">
      <UserSettings />
    </div>
    <UserCreate :visible="createUserDialog" @close="createUserDialog = false" @update="onUpdate" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { ADMIN, DEVELOPER, USER } from '@/assets/data/userRoles'
import UserSettings from './UserSettings'
import UserCreate from '@/components/users/UserCreate'
export default {
  name: 'RedaktorerHome',
  components: {
    UserSettings,
    UserCreate,
  },
  data: () => ({
    loading: false,
    selectedItem: null,
    createUserDialog: false,
    ADMIN,
    DEVELOPER,
    USER,
    search: '',
  }),
  computed: {
    ...mapGetters('user', { getAllUser: 'getArray' }),
    users() {
      return [...this.getAllUser]
        .filter((a) => a.admin_name.toLowerCase().includes(this.search.toLowerCase()))
        .sort((a, b) => a.admin_name.localeCompare(b.admin_name))
        .map((user) => {
          return {
            ...user,
            abbr: user.admin_name
              .split(' ')
              .map((name) => name[0])
              .join(''),
          }
        })
    },
  },
  methods: {
    ...mapActions('user', { getUsers: 'readCollection' }),

    onClick({ id }) {
      this.$router.push({ name: 'RedaktorerHome', params: { id } })
    },
    async onUpdate() {
      this.loading = true
      await this.getUsers()
      this.loading = false
    },
  },
}
</script>

<style lang="less" scoped>
.admins {
  border-left: 1px solid #ccc;
  overflow: hidden;
  display: grid;
  grid-template-columns: 350px 1fr;
  grid-template-rows: 1fr;
  grid-column-gap: 5px;
  margin-left: -12px;
  margin-top: -12px;
  height: calc(100vh - 65px);

  .list {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: auto 1fr;
    grid-column-gap: 0px;
    grid-row-gap: 0px;
    position: relative;
    max-height: calc(100vh - 65px);
    overflow-y: hidden;
    .list-inner {
      overflow: auto;
    }
    .controlls {
      display: flex;
      justify-content: space-between;
      gap: 20px;
    }
    .avatar-text {
      color: white;
      font-size: 12px;
    }
  }
  .content {
    border-left: 1px solid #ccc;
    border-right: 1px solid #ccc;
    padding: 12px;
  }
}
</style>
